module.exports = __webpack_public_path__ + "img/GERA_home_1.jpg";